// CATALOGOS DE FACTURACION
import RegimenFiscal    from "../views/catalogos/regimenfiscal/List.vue";
import UsoCfdi          from "../views/catalogos/usocfdi/List.vue";
import ClaveProdServ    from "../views/catalogos/claveprodserv/List.vue";
import MetodoPago       from "../views/catalogos/metodopago/List.vue";
import FormaPago        from "../views/catalogos/formapago/List.vue";
import Unidades         from "../views/catalogos/unidades/List.vue";
import Moneda           from "../views/catalogos/moneda/List.vue";
import TipoRelacionCfdi from "../views/catalogos/tiporelacioncfdi/List.vue";
import Bancos           from "../views/catalogos/bancos/List.vue";
import ObjetoImpuesto   from "../views/catalogos/objetoImpuesto/List.vue";
import Impuestos        from "../views/catalogos/impuestos/List.vue";
import ConceptosFYM     from "../views/catalogos/conceptosFYM/List.vue";

//CONFIGURACION DE CARTA PORTE
import Cartaporte     from "../views/modulos/finanzas/cartaporte/List.vue";
import CartaporteForm     from "../views/modulos/finanzas/cartaporte/Form.vue";
import CpBanderaUnidad     from "../views/catalogos/cpBanderaUnidad/List.vue";
import CpProductoServicio     from "../views/catalogos/cpProductoServicio/List.vue";
import CpClaveTransporte     from "../views/catalogos/cpClaveTransporte/List.vue";
import CpConfigAutoTransporte     from "../views/catalogos/cpConfigAutoTransporte/List.vue";
import CpFiguraTransporte     from "../views/catalogos/cpFiguraTransporte/List.vue";
import CpMaterialPeligroso     from "../views/catalogos/cpMaterialPeligroso/List.vue";
import CpNacionalidad     from "../views/catalogos/cpNacionalidad/List.vue";
import CpParteTransporte     from "../views/catalogos/cpParteTransporte/List.vue";
import CpPermisoSct     from "../views/catalogos/cpPermisoSct/List.vue";
import CpSubTipoRemolque     from "../views/catalogos/cpSubTipoRemolque/List.vue";
import CpTipoEmbalaje     from "../views/catalogos/cpTipoEmbalaje/List.vue";
import CpClaveUnidadPeso     from "../views/catalogos/cpClaveUnidadPeso/List.vue";
import CpPais     from "../views/catalogos/cpPais/List.vue";
import CpEstado     from "../views/catalogos/cpEstado/List.vue";
import CpMunicipio     from "../views/catalogos/cpMunicipio/List.vue";
import CpColonia     from "../views/catalogos/cpColonia/List.vue";
import CpLocalidad     from "../views/catalogos/cpLocalidad/List.vue";
import CpDestinos     from "../views/catalogos/cpDestinos/List.vue";
import CpChofer     from "../views/catalogos/cpChofer/List.vue";
import CpVehiculo     from "../views/catalogos/cpVehiculo/List.vue";

// FACTURACION
import CotzPendientes   from "../views/modulos/finanzas/cotizaciones/ListCotizaciones.vue";
import CotzFacturadas   from "../views/modulos/finanzas/cotizaciones/ListCotizacionesFact.vue";
import Factura          from "../views/modulos/finanzas/facturas/List.vue";
import FacturaForm      from "../views/modulos/finanzas/facturas/Form.vue";
import NotaVenta        from "../views/modulos/finanzas/notaVenta/List.vue";
import NotaVentaForm    from "../views/modulos/finanzas/notaVenta/Form.vue";
import NotaPago         from "../views/modulos/finanzas/notaPago/List.vue";
import NotaPagoForm     from "../views/modulos/finanzas/notaPago/Form.vue";
import NotaCredito      from "../views/modulos/finanzas/notaCredito/List.vue";
import NotaCreditoForm  from "../views/modulos/finanzas/notaCredito/Form.vue";
import CuentasPorCobrar from "../views/modulos/finanzas/cuentasCobrarPagar/cuentasCobrar/List.vue";
import CuentasPorCobrarCliente from "../views/modulos/finanzas/cuentasCobrarPagar/cuentasCobrar/ListCliente.vue";
import CuentasPorPagar from "../views/modulos/finanzas/cuentasCobrarPagar/cuentasPagar/List.vue";
import CuentasPorPagarProveedor from "../views/modulos/finanzas/cuentasCobrarPagar/cuentasPagar/ListProveedor.vue";

import ReporteVenta     from "../views/modulos/finanzas/reporteVenta/RepVenta.vue";
import ReportePreventa  from "../views/modulos/finanzas/reportePreventa/RepPreventa.vue";
import IndicadorResultados from "../views/modulos/finanzas/indicadorResultado/Indicador.vue";
import FacturaTimbrada  from "../views/modulos/finanzas/facturasTimbradas/List.vue";
import GraficasCuentas from "../views/modulos/finanzas/graficascuentas/GraficasCuentas.vue"

const VarRutasFinanzas=[
    {
        path: '/Regimenfiscal',
        name: 'regimenfiscal',
        component: RegimenFiscal,
        props: true
    },
    {
        path: '/UsoDeCfdi',
        name: 'usocfdi',
        component: UsoCfdi,
        props: true
    },
    {
        path: '/ClaveProductosyServicios',
        name: 'claveprodserv',
        component: ClaveProdServ,
        props: true
    },
    {
        path: '/MetodoDePago',
        name: 'metodopago',
        component: MetodoPago,
        props: true
    },
    {
        path: '/FormaDePago',
        name: 'formapago',
        component: FormaPago,
        props: true
    },
    {
        path: '/UnidadesDeMedida',
        name: 'unidades',
        component: Unidades,
        props: true
    },
    {
        path: '/Moneda',
        name: 'moneda',
        component: Moneda,
        props: true
    },
    {
        path: '/TipoDeRelacionCFDI',
        name: 'tiporelacioncfdi',
        component: TipoRelacionCfdi,
        props: true
    },
    {
        path: '/Bancos',
        name: 'bancos',
        component: Bancos,
        props: true
    },
    {
        path: '/ObjetoImpuesto',
        name: 'objetoimpuesto',
        component: ObjetoImpuesto,
        props: true
    },
    {
        path: '/Impuestos',
        name: 'impuesto',
        component: Impuestos,
        props: true
    },
    {
        path: '/ConceptosFYM',
        name: 'conceptosfym',
        component: ConceptosFYM,
        props: true
    },
    {
        path: '/CotrizacionesPendientes',
        name: 'cotzPendientes',
        component: CotzPendientes,
        props: true
    },
    {
        path: '/CotrizacionesFacturadas',
        name: 'cotzfacturadas',
        component: CotzFacturadas,
        props: true
    },
    {
        path: '/Facturas',
        name: 'factura',
        component: Factura,
        props: true
    },
    {
        path: '/FacturasForm',
        name: 'facturaform',
        component: FacturaForm,
        props: true
    },
    {
        path: '/NotasDeVenta',
        name: 'notaventa',
        component: NotaVenta,
        props: true
    },
    {
        path: '/NotasDeVentaForm',
        name: 'notaventaform',
        component: NotaVentaForm,
        props: true
    },
    {
        path: '/NotasDePago',
        name: 'notapago',
        component: NotaPago,
        props: true
    },
    {
        path: '/NotasDePagoForm',
        name: 'notapagoform',
        component: NotaPagoForm,
        props: true
    },
    {
        path: '/NotasDeCredito',
        name: 'notacredito',
        component: NotaCredito,
        props: true
    },
    {
        path: '/NotasDeCreditoForm',
        name: 'notacreditoform',
        component: NotaCreditoForm,
        props: true
    },
    {
        path: '/CuentasPorCobrar',
        name: 'cuentaporcobrar',
        component: CuentasPorCobrar,
        props: true
    },
    {
        path: '/CuentasPorCobrarCliente',
        name: 'cuentaporcobrarcliente',
        component: CuentasPorCobrarCliente,
        props: true
    },
    {
        path: '/CuentasPorPagar',
        name: 'cuentaporpagar',
        component: CuentasPorPagar,
        props: true
    },
    {
        path: '/CuentasPorPagarProveedor',
        name: 'cuentaporpagarproveedor',
        component: CuentasPorPagarProveedor,
        props: true
    },
    {
        path: '/CpBanderaUnidad',
        name: 'cpbanderaunidad',
        component: CpBanderaUnidad,
        props: true
    },
    {
        path: '/CpProductoServicio',
        name: 'cpproductoservicio',
        component: CpProductoServicio,
        props: true
    },
    {
        path: '/CpClaveTransporte',
        name: 'cpclavetransporte',
        component: CpClaveTransporte,
        props: true
    },
    {
        path: '/CpConfigAutoTransporte',
        name: 'cpconfigautotransporte',
        component: CpConfigAutoTransporte,
        props: true
    },
    {
        path: '/CpFiguraTransporte',
        name: 'cpfiguratransporte',
        component: CpFiguraTransporte,
        props: true
    },
    {
        path: '/CpMaterialPeligroso',
        name: 'cpmaterialpeligroso',
        component: CpMaterialPeligroso,
        props: true
    },
    {
        path: '/CpNacionalidad',
        name: 'cpnacionalidad',
        component: CpNacionalidad,
        props: true
    },
    {
        path: '/CpParteTransporte',
        name: 'cppartetransporte',
        component: CpParteTransporte,
        props: true
    },
    {
        path: '/CpPermisoSct',
        name: 'cppermisosct',
        component: CpPermisoSct,
        props: true
    },
    {
        path: '/CpSubTipoRemolque',
        name: 'cpsubtiporemolque',
        component: CpSubTipoRemolque,
        props: true
    },
    {
        path: '/CpTipoEmbalaje',
        name: 'cptipoembalaje',
        component: CpTipoEmbalaje,
        props: true
    },
    {
        path: '/CpClaveUnidadPeso',
        name: 'cpclaveunidadpeso',
        component: CpClaveUnidadPeso,
        props: true
    },
    {
        path: '/CpEstado',
        name: 'cpestado',
        component: CpEstado,
        props: true
    },
    {
        path: '/CpPais',
        name: 'cppais',
        component: CpPais,
        props: true
    },
    {
        path: '/CpMunicipio',
        name: 'cpmunicipio',
        component: CpMunicipio,
        props: true
    },
    {
        path: '/CpColonia',
        name: 'cpcolonia',
        component: CpColonia,
        props: true
    },
    {
        path: '/CpLocalidad',
        name: 'cplocalidad',
        component: CpLocalidad,
        props: true
    },
    {
        path: '/CpDestinos',
        name: 'cpdestinos',
        component: CpDestinos,
        props: true
    },
    {
        path: '/CpChofer',
        name: 'cpchofer',
        component: CpChofer,
        props: true
    },
    {
        path: '/CpVehiculo',
        name: 'cpvehiculo',
        component: CpVehiculo,
        props: true
    },
    {
        path: '/Cartaporte',
        name: 'cartaporte',
        component: Cartaporte,
        props: true
    },
    {
        path: '/CartaporteForm',
        name: 'cartaporteform',
        component: CartaporteForm,
        props: true
    },
    {
        path: '/ReporteVenta',
        name: 'reporteventa',
        component: ReporteVenta,
        props: true
    },
    {
        path: '/ReportePreventa',
        name: 'reportepreventa',
        component: ReportePreventa,
        props: true
    },
    {
        path: '/IndicadorResultados',
        name: 'indicadorresultados',
        component: IndicadorResultados,
        props: true
    },
    {
        path: '/GraficasCuentas',
        name: 'graficaCuentas',
        component: GraficasCuentas,
        props: true
    },
    {
        path: '/FacturasTimbradas',
        name: 'facturaTimbrada',
        component: FacturaTimbrada,
        props: true
    },
]

export default {
    VarRutasFinanzas
}